import { all } from 'redux-saga/effects';
import InterviewSaga from './interviewSaga';
export default function* rootSaga() {
    yield all([InterviewSaga()]);
}
